(function () {
    'use strict';

    angular
        .module('app')
        .service('juiceWebApiService', service);

    service.$inject = ['$http', 'urlHelper'];

    /** @ngInject */
    function service($http, urlHelper) {
        var baseUrl = urlHelper.getSuperbrandApiUrl() + 'juicewebapi/';

        this.getMemberDetails = function (memberId) {
            var url = baseUrl + 'members/' + encodeURIComponent(memberId);

            return $http.get(url).then(function (response) {
                
                return response.data;
            });
        }

        this.getPolicyDocuments = function (memberId, policyNumber, policyHash) {
            var path = baseUrl + 'members/' + encodeURIComponent(memberId) + '/policies/' + policyNumber + '/documents';
            var url = path + '?policyHash=' + encodeURIComponent(policyHash)

            return $http.get(url).then(function (response) {

                return response.data;
            });
        }

        this.updatePolicy = function (memberId, policyNumber, request) {
            var url = baseUrl + 'members/' + encodeURIComponent(memberId) + '/policies/' + policyNumber;

            return $http.patch(url, request);
        }

        this.getQuote = function (quoteId) {
            var url = baseUrl + 'quotes/' + encodeURIComponent(quoteId);

            return $http.get(url).then(function (response) {

                return response.data;
            });
        }

        this.calculatePrice = function (request) {
            var url = baseUrl + 'products/' + request.productName + '/prices';

            return $http.post(url, request).then(function (response) {

                return response.data;
            });
        }

        this.purchasePolicy = function (request) {
            var url = baseUrl + 'products/' + request.productName + '/policies';

            return $http.post(urlHelper.getSuperbrandSiteUrl() + '/jrwarea/surface/ProductName/index', {
                productName: request.productName
            }).then(function () {
                return $http.post(url, request).then(function (response) {
                    return response.data;
                });
            });
        }

        this.checkCustomer = function (request) {
            var url = baseUrl + 'customers/' + request.productName + '/checks';

            return $http.post(url, request).then(function (response) {
                return response.data;
            });
        }

        this.createPaymentTransaction = function (request) {
            var url = baseUrl + "createTransaction";

            return $http.post(url, request).then(function (response) {
                return response.data;
            });
        }

        this.getVoucherOfPolicy = function (policyNumber, productName, productType, revisionMajor) {
            var url = `${baseUrl}voucher/${policyNumber}?productName=${productName}&productType=${productType}&revisionMajor=${revisionMajor}`

            return $http.get(url).then(function (response) {
                return response.data;
            })
            .catch((error) => {
                console.log("getVoucherOfPolicy error", error);
            });
        }

        this.searchAddress = function (search) {
            var url = `${baseUrl}addresses?search=${search}`

            return $http.get(url).then(function (response) {
                return response.data;
            })
                .catch((error) => {
                    console.log("searchAddress error", error);
                });
        }

        this.getAddress = function (addressID) {
            var url = `${baseUrl}addresses/${addressID}`

            return $http.get(url).then(function (response) {
                return response.data;
            })
                .catch((error) => {
                    console.log("getAddress error", error);
                });
        }
    }
}());
